import { useEffect, useMemo, useState } from "react";
import { hasCmHighIncrease } from "./useCmPublishRows";

export function useCmRowSelection(open, allModifiedRowKeys, cmEditedRows, threshold) {
  const [selectedRows, setSelectedRows] = useState({});

  useEffect(() => {
    if (!open) return;
    const initial = {};
    allModifiedRowKeys.forEach((key) => {
      initial[key] = !hasCmHighIncrease(cmEditedRows[key], threshold);
    });
    setSelectedRows(initial);
  }, [open, allModifiedRowKeys, cmEditedRows, threshold]);

  const hasSelectedRows = useMemo(
    () => Object.values(selectedRows).some(Boolean),
    [selectedRows],
  );

  const allSelected = useMemo(
    () =>
      allModifiedRowKeys.length > 0 &&
      allModifiedRowKeys.every((key) => selectedRows[key]),
    [allModifiedRowKeys, selectedRows],
  );

  const someSelected = useMemo(
    () => allModifiedRowKeys.some((key) => selectedRows[key]) && !allSelected,
    [allModifiedRowKeys, selectedRows, allSelected],
  );

  const toggleRow = (key) =>
    setSelectedRows((prev) => ({ ...prev, [key]: !prev[key] }));

  const toggleAll = () => {
    const newValue = !allSelected;
    const newSelection = {};
    allModifiedRowKeys.forEach((key) => {
      newSelection[key] = newValue;
    });
    setSelectedRows(newSelection);
  };

  const resetSelection = () => setSelectedRows({});

  return {
    selectedRows,
    hasSelectedRows,
    allSelected,
    someSelected,
    toggleRow,
    toggleAll,
    resetSelection,
  };
}
